export const brokenUserUuidMapping = {
  "fc7v@kk.dk": "FC7V@kk.dk",
  "ia68@kk.dk": "IA68@kk.dk",
  "b20f@kk.dk": "B20F@kk.dk",
  "et6i@kk.dk": "ET6I@kk.dk",
  "hv5r@kk.dk": "hc5r@kk.dk"
};



// WEBPACK FOOTER //
// ./src/app/utils/broken-user-uuid-mapping.ts